import styled from 'styled-components';
import { Box } from '../Core';

export const ButtonActions = styled(Box)`
  display: flex;
  justify-content: center;
  padding: ${({ theme }) => `${theme.spacing8}px ${theme.spacing16}px`};
  margin: ${({ theme }) => `0 -${theme.spacing16}px -${theme.spacing8}px`};
  border-top: ${({ theme }) => `solid 1px ${theme.colors.gray['040']}`};
`;
